"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
// @ts-nocheck
var utils_1 = __importDefault(require("@blaze-react/utils"));
var react_1 = __importStar(require("react"));
var isContentLoaded_1 = __importDefault(require("./isContentLoaded"));
var logic_1 = __importDefault(require("./logic"));
var RangeFilter = function (_a) {
    var _b;
    var label = _a.label, modifier = _a.modifier, onChange = _a.onChange, required = _a.required, error = _a.error, validationMessage = _a.validationMessage, value = _a.value, name = _a.name, id = _a.id, _c = _a.utils, buildClassNames = _c.buildClassNames, ErrorMessage = _c.ErrorMessage, attrs = __rest(_a, ["label", "modifier", "onChange", "required", "error", "validationMessage", "value", "name", "id", "utils"]);
    var _d = react_1.useState(value || {}), inputs = _d[0], setInputs = _d[1];
    var _e = react_1.useState(error), newError = _e[0], setError = _e[1];
    react_1.useEffect(function () {
        setError(error);
    }, [error]);
    react_1.useEffect(function () {
        isContentLoaded_1["default"](init, reInit);
    }, []);
    var getMinMax = function (minvalue, maxvalue) {
        var newValue = __assign(__assign({}, inputs), { minValue: minvalue, maxValue: maxvalue });
        onChange({ value: newValue });
        setInputs(newValue);
    };
    var init = function () {
        logic_1["default"](id, getMinMax);
    };
    var reInit = function (time) {
        if (time === void 0) { time = 1000; }
        setTimeout(init, time);
    };
    var modifierClassName = buildClassNames((_b = {},
        _b["form-field--" + modifier] = !!modifier,
        _b));
    var formatNumbers = function (num) { return num > 9999 ? Number(num).toLocaleString('en-US') : num; };
    var requiredClassName = buildClassNames({ required: required });
    var _f = inputs.min, min = _f === void 0 ? 0 : _f, _g = inputs.max, max = _g === void 0 ? 0 : _g, _h = inputs.step, step = _h === void 0 ? 1 : _h, _j = inputs.minValue, minValue = _j === void 0 ? 0 : _j, _k = inputs.maxValue, maxValue = _k === void 0 ? 0 : _k;
    var formatedMinValue = formatNumbers(minValue);
    var formatedMaxValue = formatNumbers(maxValue);
    return (react_1["default"].createElement("div", { className: "form-field form-field--range " + modifierClassName },
        label && (react_1["default"].createElement("label", { htmlFor: attrs.id, className: requiredClassName }, label)),
        react_1["default"].createElement("div", { className: "values" },
            react_1["default"].createElement("span", null, formatedMinValue),
            react_1["default"].createElement("span", null, formatedMaxValue)),
        react_1["default"].createElement("div", { min: min, max: max, step: step, "min-value": minValue, "max-value": maxValue, id: name + "Range", className: "range__filter " + id },
            react_1["default"].createElement("div", { className: "range__filter--left" },
                react_1["default"].createElement("span", null)),
            react_1["default"].createElement("div", { className: "range__filter--right" },
                react_1["default"].createElement("span", null)),
            react_1["default"].createElement("div", { className: "range__filter--line" },
                react_1["default"].createElement("span", null))),
        newError && react_1["default"].createElement(ErrorMessage, { message: validationMessage })));
};
RangeFilter.defaultProps = {
    error: false,
    label: "",
    modifier: "",
    name: "",
    validationMessage: "This field is required"
};
exports["default"] = utils_1["default"](RangeFilter);
